var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.944 1.167H5.055c-2.123 0-3.389 1.265-3.389 3.389v4.882c0 2.13 1.266 3.395 3.39 3.395h4.882c2.123 0 3.389-1.265 3.389-3.389V4.556c.006-2.124-1.26-3.39-3.383-3.39z",
    fill: "#009B62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67 9.088a.437.437 0 0 1-.308-.128L4.71 7.31a.44.44 0 0 1 0-.62.44.44 0 0 1 .618 0l1.342 1.343 2.998-2.999a.44.44 0 0 1 .618 0c.17.17.17.45 0 .619L6.98 8.96a.437.437 0 0 1-.31.128z",
    fill: "#009B62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDone);
export default __webpack_public_path__ + "static/media/ic-done.1034499a0069bb24699003e104c98887.svg";
export { ForwardRef as ReactComponent };